import { render, staticRenderFns } from "./EditingDFTextbox.vue?vue&type=template&id=b8c73d6a&"
import script from "./EditingDFTextbox.vue?vue&type=script&lang=js&"
export * from "./EditingDFTextbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports